import * as yup from 'yup'

export const schemaAddNewContact = yup.object().shape({
    contact_label: yup.array().of(yup.string()).required(),
    contact_roles: yup.array().of(yup.string()).required(),
    contact_name: yup.string().required(),
    contact_email: yup.string().email().required(),
    contact_phone: yup.string().required(),
    contact_position: yup.string().required(),
    contact_address: yup.string().required(),
    contact_source: yup.string().required(),
    enable_authentication: yup.boolean(),
    password: yup.string().when('enable_authentication', {
        is: true,
        then: (schema) =>
            schema
                .min(8, 'Password must be at least 8 characters')
                .required('Password is required'),
        otherwise: (schema) => schema.notRequired(),
    }),
    password_confirmation: yup.string().when('enable_authentication', {
        is: true,
        then: (schema) =>
            schema
                .oneOf([yup.ref('password')], 'Passwords must match')
                .required('Confirm password is required'),
        otherwise: (schema) => schema.notRequired(),
    }),
    send_welcome_email: yup.boolean(),
})

// Keep for backwards compatibility but not used anymore
export const schemaAddNewContactWithAuth = schemaAddNewContact
